export const movieList = [
  {
    id: "m-1",
    title: "星际拾荒者",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "冒险"],
    rating: 8.6,
    popularity: 98200,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20scavenging%20among%20glowing%20space%20debris%2C%20deep%20charcoal%20background%2C%20dramatic%20orange%20rim%20light%2C%20moody%20atmospheric%20tone%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-scifi-01&orientation=portrait",
    director: "亚历克斯·里德",
    cast: ["伊桑·科尔", "玛拉·文森", "诺亚·贝恩"],
    summary: "一艘废弃采矿船的残骸里，藏着足以颠覆星际联盟的秘密。",
    synopsis:
      "在资源枯竭的边境星系，拾荒者凯追踪一艘失联多年的采矿船，却在残骸中发现一份加密档案。随着真相层层揭开，他被卷入一场横跨三大星系的阴谋。影片以冷峻的宇宙美学与紧凑节奏，讲述一个普通人在宏大秩序前的选择与救赎。",
  },
  {
    id: "m-2",
    title: "暗夜追踪",
    year: 2024,
    region: "大陆",
    genres: ["犯罪", "悬疑"],
    rating: 8.2,
    popularity: 87400,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20of%20a%20lone%20detective%20in%20a%20rain-soaked%20alley%20at%20night%2C%20deep%20charcoal%20background%2C%20dramatic%20orange%20rim%20light%2C%20moody%20noir%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-crime-02&orientation=portrait",
    director: "陈立衡",
    cast: ["张骁", "林晚", "赵明宇"],
    summary: "连续七起悬案指向同一串数字，刑警必须在下一个夜晚前破解它。",
    synopsis:
      "雨夜的城市像一张被反复涂抹的旧照片。刑警队长陆沉接手一桩看似普通的失踪案，却发现它与多年前未结的连环案有着惊人的关联。时间一点点流逝，真相与谎言在霓虹与积水中交错，他必须在天亮之前找到那个被刻意遗忘的名字。",
  },
  {
    id: "m-3",
    title: "春风十里不如你",
    year: 2023,
    region: "大陆",
    genres: ["爱情", "剧情"],
    rating: 7.8,
    popularity: 65100,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20movie%20poster%20of%20two%20silhouettes%20under%20soft%20spring%20cherry%20blossoms%20at%20dusk%2C%20deep%20charcoal%20background%2C%20warm%20orange%20glow%2C%20tender%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-romance-03&orientation=portrait",
    director: "苏晴",
    cast: ["周雨桐", "唐亦舟", "顾小满"],
    summary: "两条错过的平行人生，在十年后的春天重新相遇。",
    synopsis:
      "大学时代的两个年轻人因为一次误会各自远行，十年后在故乡的樱花道上再次相遇。时间改变了他们的模样，却没有改变心底那句始终没说出口的话。影片用细腻的日常与克制的对白，讲述一段关于勇气与遗憾的爱情故事。",
  },
  {
    id: "m-4",
    title: "都市迷航",
    year: 2025,
    region: "大陆",
    genres: ["剧情", "悬疑"],
    rating: 8.0,
    popularity: 76800,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20mystery%20movie%20poster%20of%20neon%20reflections%20on%20wet%20city%20streets%20with%20a%20solitary%20figure%20walking%2C%20dark%20charcoal%20background%2C%20warm%20orange%20accent%20light%2C%20moody%20atmosphere%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-urban-04&orientation=portrait",
    director: "何一鸣",
    cast: ["吴桐", "李若曦", "郑凯"],
    summary: "一个习惯深夜加班的普通人，发现整座城市正在遗忘同一个人。",
    synopsis:
      "设计师沈川在地铁末班车上捡到一本无名日记，随后他注意到城市中所有关于某个人的痕迹都在悄悄消失。为了弄清真相，他在深夜的写字楼与地下通道之间穿行，最终发现被遗忘的那个人，或许正是他自己。",
  },
  {
    id: "m-5",
    title: "极地重生",
    year: 2022,
    region: "欧美",
    genres: ["冒险", "动作"],
    rating: 7.9,
    popularity: 58200,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20survival%20adventure%20movie%20poster%20of%20a%20climber%20on%20a%20frozen%20arctic%20ridge%20under%20aurora%20sky%2C%20deep%20charcoal%20background%2C%20dramatic%20orange%20rim%20light%2C%20epic%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-arctic-05&orientation=portrait",
    director: "卢卡斯·格兰特",
    cast: ["莱昂·斯科特", "艾玛·雷德", "丹尼尔·弗罗斯特"],
    summary: "坠机之后，他要用一百天穿越无人冰原，只为兑现一个承诺。",
    synopsis:
      "科考飞机在北极圈坠毁，唯一幸存者带着半张地图和一盒火柴踏上归途。极夜、风暴与饥饿一次次将他逼向极限，而记忆中女儿的声音成为他继续前行的唯一理由。一场关于生存、意志与爱的极限之旅。",
  },
  {
    id: "m-6",
    title: "樱花之约",
    year: 2024,
    region: "日韩",
    genres: ["爱情", "剧情"],
    rating: 8.3,
    popularity: 71200,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20movie%20poster%20of%20a%20couple%20sharing%20an%20umbrella%20on%20a%20Tokyo%20street%20with%20cherry%20blossoms%20falling%2C%20deep%20charcoal%20background%2C%20warm%20orange%20glow%2C%20nostalgic%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-sakura-06&orientation=portrait",
    director: "山本由佳",
    cast: ["佐藤遥", "木村拓", "伊藤绫"],
    summary: "每年樱花盛开的那一周，她都会在同一座车站等一个不会来的人。",
    synopsis:
      "在东京近郊的小站，理惠连续七年守着一个约定。今年春天，一位陌生旅人带来了改变一切的旧信。影片以细腻的四季更替为背景，讲述关于等待、释怀与重新出发的温柔故事。",
  },
  {
    id: "m-7",
    title: "机甲黎明",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "动作"],
    rating: 8.5,
    popularity: 92100,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20action%20movie%20poster%20of%20a%20towering%20humanoid%20mecha%20standing%20in%20a%20ruined%20city%20at%20dawn%2C%20deep%20charcoal%20background%2C%20glowing%20orange%20accents%2C%20epic%20dramatic%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-mecha-07&orientation=portrait",
    director: "凯文·霍顿",
    cast: ["杰克·里维斯", "索菲亚·蒙", "马克·安德森"],
    summary: "最后一台退役机甲，被一名失意飞行员重新唤醒。",
    synopsis:
      "战争结束后，巨型机甲被逐一封存。前飞行员艾拉在一座废弃机库中发现了代号「黎明」的最后一台机型。当新的威胁逼近城市，她必须重新登上驾驶舱，与这台被遗忘的钢铁伙伴一同面对黎明前的黑暗。",
  },
  {
    id: "m-8",
    title: "无声证词",
    year: 2023,
    region: "大陆",
    genres: ["犯罪", "悬疑"],
    rating: 8.1,
    popularity: 62300,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20mystery%20movie%20poster%20of%20an%20empty%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20deep%20charcoal%20background%2C%20warm%20orange%20light%20beam%2C%20tense%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-silent-08&orientation=portrait",
    director: "沈墨白",
    cast: ["段天", "许清", "谢文彬"],
    summary: "唯一的目击者无法开口，检察官必须在沉默中找出真相。",
    synopsis:
      "一起发生在旧工厂区的案件没有任何物证，唯一的目击者是位失语的少年。检察官程雪从一个个微小的细节入手，在看似完美的证词背后，拼凑出一段被刻意隐藏的完整真相。",
  },
  {
    id: "m-9",
    title: "深海呼唤",
    year: 2024,
    region: "欧美",
    genres: ["科幻", "悬疑"],
    rating: 7.7,
    popularity: 54800,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20thriller%20movie%20poster%20of%20a%20deep%20sea%20diver%20facing%20a%20vast%20glowing%20creature%20in%20dark%20water%2C%20deep%20charcoal%20background%2C%20orange%20bioluminescent%20accents%2C%20eerie%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-ocean-09&orientation=portrait",
    director: "娜塔莎·林奇",
    cast: ["奥利弗·凯", "汉娜·布克", "路易斯·唐"],
    summary: "深海科考队的声呐，接收到了来自一万米以下的回应。",
    synopsis:
      "一支国际科考队深入马里亚纳海沟，试图解开深海异常信号的来源。随着下潜深度增加，船员们开始听见无法解释的呼唤，而海底那团庞大而古老的光，似乎早已等待他们许久。",
  },
  {
    id: "m-10",
    title: "追风少年",
    year: 2021,
    region: "大陆",
    genres: ["剧情", "冒险"],
    rating: 7.4,
    popularity: 43100,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20coming%20of%20age%20movie%20poster%20of%20teenagers%20riding%20bikes%20on%20a%20coastal%20road%20at%20sunset%2C%20deep%20charcoal%20background%2C%20warm%20orange%20glow%2C%20nostalgic%20free-spirited%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-youth-10&orientation=portrait",
    director: "顾城",
    cast: ["韩烨", "苏婉", "徐一诺"],
    summary: "三个少年用一辆旧单车，骑完了整个夏天。",
    synopsis:
      "小镇的夏天漫长而燥热，三个即将分别的少年决定用一场旅程为青春作结。沿着海岸线，他们遇到暴雨、迷路与争吵，也第一次认真谈论梦想。一段关于友谊与成长的清爽公路故事。",
  },
  {
    id: "m-11",
    title: "古堡疑云",
    year: 2022,
    region: "欧美",
    genres: ["悬疑", "犯罪"],
    rating: 7.6,
    popularity: 49500,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20movie%20poster%20of%20a%20foggy%20old%20gothic%20castle%20silhouetted%20against%20moonlight%2C%20deep%20charcoal%20background%2C%20warm%20orange%20window%20light%2C%20suspenseful%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-castle-11&orientation=portrait",
    director: "爱德华·布莱克",
    cast: ["查理·诺曼", "伊莎贝尔·格林", "维克多·霍尔"],
    summary: "一场暴雪困住了古堡里的所有人，而凶手就在他们中间。",
    synopsis:
      "受邀参加家族聚会的宾客在暴雪夜被困于山中古堡。当主人离奇身亡，每个人都成为嫌疑人。侦探需要在有限的时间里，从紧闭的门窗与彼此矛盾的陈述中，找出那个被隐藏许久的动机。",
  },
  {
    id: "m-12",
    title: "幻梦之城",
    year: 2025,
    region: "日韩",
    genres: ["动画", "冒险"],
    rating: 8.7,
    popularity: 88900,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20fantasy%20movie%20poster%20of%20a%20floating%20dream%20city%20above%20the%20clouds%20at%20twilight%2C%20deep%20charcoal%20background%2C%20warm%20orange%20and%20gold%20glow%2C%20magical%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-fantasy-12&orientation=portrait",
    director: "高桥悠真",
    cast: ["配音：花泽香菜", "配音：神谷浩史", "配音：早见沙织"],
    summary: "少女推开阁楼的旧门，走进了只在梦中出现过的悬浮之城。",
    synopsis:
      "搬到海边小镇的少女小凪在祖母的阁楼里发现一只会说话的钟。每到午夜，钟声便会带她进入一座漂浮在云端的城市。为了找回丢失的名字，她必须在幻梦之城完成一场关于记忆与告别的冒险。",
  },
];